'use client'
import React from 'react';
// import { FacebookProvider, Page } from 'react-facebook';
import Script from 'next/script';
import FacebookProvider from './FacebookProvider';

const FacebookTimeline = async ({ children }) => {
  return (
    <FacebookProvider>
      <Script rel="preconnect" async defer crossorigin="anonymous" src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v19.0&appId=3440484716268407" nonce="ilXNuaEl" />
      <div className='sm:block hidden rounded-md overflow-hidden'>
        <iframe title='Facebook Feed' src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FREMAXExecutiveHomes&tabs=timeline&width=600&height=470&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=3440484716268407" width="600" height="470" className=''  scrolling="no" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
      </div>
      <div className='block sm:hidden rounded-md overflow-hidden'>
        <iframe title='Facebook Feed' src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FREMAXExecutiveHomes&tabs=timeline&width=380&height=400&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=3440484716268407" width="380" height="400" className=''  scrolling="no" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
      </div>
    </FacebookProvider>
  )
}

export default FacebookTimeline